export class ExportControlPost {
  countryOfResidenceId: string;
  lastGrantedCitizenshipId: string;

  constructor(clone: ExportControlPost = null) {
    this.countryOfResidenceId = '';
    this.lastGrantedCitizenshipId = '';

    if (clone) {
      this.countryOfResidenceId = clone.countryOfResidenceId;
      this.lastGrantedCitizenshipId = clone.lastGrantedCitizenshipId;
    }
  }
}
